module.exports = __webpack_public_path__ + "img/audio-play.737056b2.png";